module.exports = __webpack_public_path__ + "media/images/pc/top/keyword_okunai@3x-a69d2d133e6532fc153d2c64bd1ca100.webp";